import { call, put, takeLatest } from 'redux-saga/effects';
import EnvInfo from '../Types/envInfo';
import { getEnvInfo } from '../../api/resources';

import { loadEnvInfoFail, loadEnvInfoSuccess } from '../Actions/envInfo';

function* handleLoadEnvInfo(action) {
  try {
    const response = yield call(getEnvInfo, action.payload);
    const { data } = response;
    if (response.success) {
      const items = data;
      const totalRow = response.totalRow;
      yield put(loadEnvInfoSuccess({ data: items, totalRow }));
    }
  } catch (error) {
    yield put(loadEnvInfoFail(error));
  }
}


export default function* envInfoSaga() {
  yield takeLatest(EnvInfo.LOAD_ENVINFO, handleLoadEnvInfo);
}
